import apiClient from './axiosClient';

const getUnifiedSearchDropdownDataRequest = async (
  collection:
    | 'training'
    | 'jobs'
    | 'careers'
    | 'resources'
    | 'all'
    | 'open-jobs'
    | 'my-path'
    | '404'
    | '500'
    | 'login'
    | 'reset-password' | 'profile',
  input: string,
) => {
  return apiClient
    .get(`search/dropdown-data/${collection}`, {
      params: { input  },
    })
    .then((res) => res.data);
};

export default getUnifiedSearchDropdownDataRequest;
